module.exports = __webpack_public_path__ + "img/flood-hazard.38c3529f.png";